<template>
    <div class="tab-text">
        <div class="vx-row mb-12">
            <div class="core vx-col md:w-1/1 w-full mb-base">
                <data-table :baseUrl="baseUrl" :status="1"></data-table>
            </div>
        </div>
    </div>
</template>

<script>
import DataTable from "../DataTable";
export default {
    components: {
        DataTable,
    },
    data() {
        return {
            title: "Bill Of Material",
            baseUrl: "api/wms/v1/item-bill-of-material",
            id: null,
            date: "",
        };
    },
    methods: {},
    mounted() {},
    computed: {
        setPage: {
            get() {
                return 1;
            },
            set(val) {
                this.handleChangePage(val);
            },
        },
    },
};
</script>